module.exports = __webpack_public_path__ + "img/pen_2.a8dd9b5a.svg";